import { ref, computed } from "vue";
import { defineStore } from "pinia";
import type { BreadcrumbType } from "../types/BreadcrumbType";

export const useBreadcrumb = defineStore("BreadcrumbProvider", () => {
  const items = ref<BreadcrumbType[]>([]);

  const isTopLevel = computed(() => items.value.length <= 1);

  function set(itemsNext: BreadcrumbType[]) {
    items.value = (itemsNext ?? []).filter(Boolean);
  }

  function clear() {
    items.value = [];
  }

  return { items, isTopLevel, set, clear };
});
